module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"ru":{"not-found":"Документ не найден","close":"Закрыть"}}')
  delete Component.options._Ctor
}
